import keyCodes from "../../constants/keyCodes";
import useComboboxHandlers from "../useComboboxHandlers";
import useSanitizedInput from "../useSanitizedInput";

export const generateId = text => text.toLowerCase().replace(/\s/, "-");

export const filterOptions = ({ identity, options, search }) =>
  search
    ? options.filter(o =>
        identity(o)
          .toLowerCase()
          .includes(search.toLowerCase())
      )
    : options;

export const optionId = (inputId, index) => `${inputId}-option-${index}`;

export const initialState = ({ defaultValue, labelIdentity, value }) =>
  (value && labelIdentity(value)) ||
  (defaultValue && labelIdentity(defaultValue)) ||
  "";

export { useComboboxHandlers, useSanitizedInput, keyCodes };
